import http from 'hub-http/clients/apiClient';
import { CRM_SEARCH_URL, FETCH_ALL_CAMPAIGN_PERFORMANCE } from '../constants/api';
import { getAdCampaignIdsFromGoalTargets, getAdCampaigns } from '../utils/ads';
import { getAdCampaignCrmQuery } from '../utils/crmQueries';
import { logError } from '../utils/errorHandling';
import { addAdCampaignsToGoalTargets } from '../utils/goalTarget';
export const fetchAdCampaigns = dataQuery => {
  const GOAL_TARGET_OBJECT_ID = '0-31';
  const properties = ['objectId', 'hs_ad_network', 'hs_ad_account_id', 'hs_ad_campaign_id', 'hs_name', 'hs_status', 'hs_start_datetime', 'hs_end_datetime'];
  return http.post(CRM_SEARCH_URL, {
    data: Object.assign({
      objectTypeId: GOAL_TARGET_OBJECT_ID,
      requestOptions: {
        properties
      }
    }, dataQuery)
  }).then(data => data).catch(logError);
};
export const fetchAdsSpent = dataQuery => http.get(FETCH_ALL_CAMPAIGN_PERFORMANCE, {
  query: dataQuery
}).then(data => data);
export const setupAdCampaignsFromGoalTargets = goalTargets => {
  if (!goalTargets || !goalTargets.length) return Promise.resolve();
  const adCampaignIdsFromGoalTargets = getAdCampaignIdsFromGoalTargets(goalTargets);
  if (!adCampaignIdsFromGoalTargets || !adCampaignIdsFromGoalTargets.length) return Promise.resolve();
  const campaignDataQuery = getAdCampaignCrmQuery(adCampaignIdsFromGoalTargets);
  return fetchAdCampaigns(campaignDataQuery).then(data => {
    if (!data) return Promise.resolve(undefined);
    const adCampaigns = getAdCampaigns(data);
    const goalTargetsWithAdCampaigns = addAdCampaignsToGoalTargets(goalTargets, adCampaigns);
    return Promise.resolve(goalTargetsWithAdCampaigns);
  }).catch(logError);
};